module.exports = __webpack_public_path__ + "assets/img/2261.38bbe9ff.png";